import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=33322032"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js"
import style0 from "./WhatsappIcon.vue?vue&type=style&index=0&id=33322032&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports